import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { StateSetting } from "@shared/types/StateSetting";

export const getStateSettings = async (): Promise<StateSetting> => {
  try {
    return await HttpPromise({
      method: "GET",
      url: "/api/retailer/state_settings",
    });
  } catch (e) {
    return <StateSetting>{};
  }
};
